/**
 *  Product-related constants for use in product reviews
 */

// TODO: In another effort, let's match what's done in collectionConstants.js
//       and have constants for the handles (should match the handles in Shopify)
//       and generate all product keys using getProductKeyFromHandle()
// Product Keys
export const REST_KEY = "rest";
export const REST_PLUS_KEY = "restPlus";
export const RESTORE_KEY = "restore";
export const WHOOP_RESTORE_KEY = "whoopRestore";
export const GROW_KEY = "grow";
export const COVERLETS_KEY = "coverlets";
export const MILESTONE_CARD_KEY = "milestoneCard";
export const REST_TRAVEL_CASE_KEY = "restTravelCase";
export const HATCH_CLOUD_PILLOW_KEY = "hatchCloudPillow";
export const REST_MINI_KEY = "restMini";
export const RESTORE_MEMBERSHIP_BUNDLE_KEY = "restoreSubscriptionBundle";
export const CORPORATE_RESTORE_MEMBERSHIP_BUNDLE_12_MONTH_KEY =
  "corporateRestoreSubscriptionBundle12Month";
export const CORPORATE_RESTORE_KEY = "corporateRestore";
export const REST_MINI_MEMBERSHIP_BUNDLE_KEY = "restMiniMembershipBundle";
export const REST_REST_PLUS_BARREL_POWER_CORD_KEY =
  "restRestPlusBarrelPowerCord";
export const REST_REST_PLUS_USB_POWER_CORD_KEY = "restPowerCordUsb";
export const RESTORE_BARREL_POWER_CORD_KEY = "restoreBarrelPowerCord";
export const REST_2ND_GEN_KEY = "rest2ndGen";
export const GIFT_CARD_KEY = "hatchGiftCard";
export const CLOUD_PILLOW_KEY = "cloudPillow";

// Shopify Metafields
export const PRODUCT_KEY = "_product_key";
export const IS_NEW_KEY = "_is_new";
export const GALLERY_THUMBNAIL_IMAGE_KEY = "_gallery_thumbnail_image";
export const GALLERY_PRODUCT_IMAGE_KEY = "_gallery_product_image";
export const CART_DESCRIPTION_KEY = "_cart_description";
export const ALT_LINE_ITEM_DISPLAY_NAME_KEY = "_line_item_display_name";
export const RECOMMENDED_PRODUCT_IMAGE_KEY = "_upsell_image";
export const IMAGE_ALT_TEXT_KEY = "_image_alt_text";
export const RECOMMENDED_PRODUCTS_KEY = "_recommended_products";
export const REVIEWS_IMAGE_KEY = "_reviews_image";
export const SHORT_DESCRIPTION_KEY = "_short_description";
export const PROMOTIONAL_MESSAGE_KEY = "_promo_message";
export const RECOMMENDED_PRODUCT_DESCRIPTION_KEY = "_rec_product_description";
export const METAFIELD_LIST_DELIMITER = "|";
export const SWATCH_IMAGE_KEY = "_swatch_image";
export const COLOR_SPECIFIC_GALLERY_IMAGES_KEY =
  "_color_specific_gallery_images";
export const COLOR_SPECIFIC_GALLERY_IMAGES_ALT_TEXT_KEY =
  "_image_gallery_alt_text";
export const EDITORIAL_COPY_KEY = "_editorial_copy";
export const EDITORIAL_BLURB_COPY_KEY = "_editorial_blurb_copy";
export const FEATURES_AND_SPECS_KEY = "_features_and_specs";
export const PRODUCT_SPECS_KEY = "_product_specs";
export const MATERIALS_AND_CARE_KEY = "_materials_and_care";
export const SEO_PRODUCT_DESCRIPTION = "_seo_product_description";
export const VARIANT_KEY = "_variant_key";
export const VARIANT_SLUG = "_variant_slug";
export const FULFILLMENT_SERVICE_KEY = "_fulfillment_service";

export const PRODUCT_KEYS = {
  REST_KEY,
  REST_PLUS_KEY,
  RESTORE_KEY,
  WHOOP_RESTORE_KEY,
  GROW_KEY,
  COVERLETS_KEY,
  MILESTONE_CARD_KEY,
  REST_TRAVEL_CASE_KEY,
  HATCH_CLOUD_PILLOW_KEY,
  REST_MINI_KEY,
  CLOUD_PILLOW_KEY,
  REST_REST_PLUS_BARREL_POWER_CORD_KEY,
  RESTORE_BARREL_POWER_CORD_KEY,
  REST_REST_PLUS_USB_POWER_CORD_KEY,
};

export const SHOPIFY_METAFIELD_KEYS = {
  productKey: PRODUCT_KEY,
  isNewKey: IS_NEW_KEY,
  galleryThumbnailImageKey: GALLERY_THUMBNAIL_IMAGE_KEY,
  galleryProductImageKey: GALLERY_PRODUCT_IMAGE_KEY,
  cartDescriptionKey: CART_DESCRIPTION_KEY,
  recommendedProductImageKey: RECOMMENDED_PRODUCT_IMAGE_KEY,
  imageAltTextKey: IMAGE_ALT_TEXT_KEY,
  recommendedProductsKey: RECOMMENDED_PRODUCTS_KEY,
  reviewsImageKey: REVIEWS_IMAGE_KEY,
  shortDescriptionKey: SHORT_DESCRIPTION_KEY,
  swatchImageKey: SWATCH_IMAGE_KEY,
  colorSpecificGalleryImages: COLOR_SPECIFIC_GALLERY_IMAGES_KEY,
  seoProductDescription: SEO_PRODUCT_DESCRIPTION,
  variantKey: VARIANT_KEY,
};

const AMAZON_FULFILLMENT = "amazon";
const EUNIOA = "eunoia";

export const SHOPIFY_PRODUCT_FULFILLMENT_MAPPING = {
  HBRC20SPO: AMAZON_FULFILLMENT,
  HBRC20FLO: AMAZON_FULFILLMENT,
  HBRC20ANI: AMAZON_FULFILLMENT,
  HBR3101: AMAZON_FULFILLMENT,
  HBRTC3700: AMAZON_FULFILLMENT,
  HBRC19ADVSL: AMAZON_FULFILLMENT,
  HBRC19DIN: AMAZON_FULFILLMENT,
  HBRC19TRA: AMAZON_FULFILLMENT,
  HBRC19UNI: AMAZON_FULFILLMENT,
  HBR2700: AMAZON_FULFILLMENT,
  HBRC19SIL: AMAZON_FULFILLMENT,
  HBRC19ALP: AMAZON_FULFILLMENT,
  HBR3100: AMAZON_FULFILLMENT,
  HBR3000: AMAZON_FULFILLMENT,
  HBG16001WHT: AMAZON_FULFILLMENT,
  HBRC18HOL: AMAZON_FULFILLMENT,
  HBRC18MOOSL: AMAZON_FULFILLMENT,
  HBRC18ITWSL: AMAZON_FULFILLMENT,
  HBRC18CON: AMAZON_FULFILLMENT,
  "852852007030_22": AMAZON_FULFILLMENT,
  HBR16001WHT: AMAZON_FULFILLMENT,
  HBR4100: AMAZON_FULFILLMENT,
  HSAM1101: EUNIOA,
  HSPM1100: EUNIOA,
  HTAM1103: EUNIOA,
  HTPM1102: EUNIOA,
};

// Shopify Misc
export const SHOPIFY_QUERY_LIMIT = 120;
export const SHOPIFY_PAGE_SIZE_QUERY_LIMIT = 250;

// Key used in utils/shop.js > constructCtaProductData and subsequently
// utils/shop.js > getImageAltText to properly set the image altText for the cart
// line item.
// This is needed because all Shopify products, regardless if variants exist or not,
// have at least 1 variant with a title of "Default Title". In order to accurately determine
// that the line item is a true product variant, we will set this key-value within the line item
// customAttributes property within constructCtaProductData when the item is first added to
// the cart so that we don't have to re-determine on every render whether this is a variant.
export const PRODUCT_IS_VARIANT_KEY = "_isVariant";

// Hatch Product Handles
// Whenever we store and access product data in the app, it should
// always use these handles in conjunction with the getProductKeyFromHandle() util.
export const HATCH_PRODUCT_HANDLES = {
  [REST_KEY]: "rest",
  [REST_PLUS_KEY]: "rest-plus",
  [COVERLETS_KEY]: "coverlets",
  [MILESTONE_CARD_KEY]: "baby-milestone-cards",
  [GROW_KEY]: "grow",
  [REST_TRAVEL_CASE_KEY]: "rest-travel-case",
  [RESTORE_KEY]: "restore",
  [REST_MINI_KEY]: "rest-mini",
  [WHOOP_RESTORE_KEY]: "whoop-restore",
  [REST_REST_PLUS_BARREL_POWER_CORD_KEY]: "rest-rest-plus-barrel-power-cord",
  [RESTORE_BARREL_POWER_CORD_KEY]: "rest-power-cord-usb",
  [REST_REST_PLUS_USB_POWER_CORD_KEY]: "restore-barrel-power-cord",
  [HATCH_CLOUD_PILLOW_KEY]: "hatch-cloud-pillow",
};

// Adults Product Handles
// Whenever we store and access product data in the app, it should
// always use these handles in conjunction with the getProductKeyFromHandle() util.
export const ADULTS_PRODUCT_HANDLES = {
  [RESTORE_KEY]: "restore",
  [CLOUD_PILLOW_KEY]: "cloud-pillow",
};
// List of Hatch products having custom product pages
export const CUSTOM_PRODUCT_PAGE_HANDLES = [
  HATCH_PRODUCT_HANDLES[REST_KEY],
  HATCH_PRODUCT_HANDLES[REST_PLUS_KEY],
  HATCH_PRODUCT_HANDLES[RESTORE_KEY],
  HATCH_PRODUCT_HANDLES[WHOOP_RESTORE_KEY],
];
